import {
  Component,
  OnInit
} from '@angular/core';

import { ChangeDetectorRef } from '@angular/core';

import {
  HttpErrorResponse
} from '@angular/common/http';

import {
  CommonModule
} from '@angular/common';

import {
  FormsModule
} from '@angular/forms';

import {
  Router
} from '@angular/router';

import Swal from 'sweetalert2';

import {
  CheckoutService,
  CheckoutData,
  CheckoutReservaResponse,
  PagamentoCartaoRequest,
  OpcaoParcelamento
} from '../../../service/checkout.service';


@Component({
  selector: 'app-checkout-cartao',
  standalone: true,

  imports: [
    CommonModule,
    FormsModule
  ],

  templateUrl: './checkout-cartao.component.html',

  styleUrl: './checkout-cartao.component.css'
})
export class CheckoutCartaoComponent implements OnInit {

  dados: CheckoutData | null = null;

  numeroCartao = '';

  nomeCartao = '';

  validadeCartao = '';

  cvv = '';

  cpfCartao = '';

  private intervaloStatus:
    ReturnType<typeof setInterval> | null = null;

  private tentativasStatus = 0;

  /**
   * 5 minutos, consultando a cada 3 segundos.
   */
  private readonly MAX_TENTATIVAS_STATUS = 100;

  /**
   * Quantidade de parcelas selecionada.
   */
  parcelas = 1;

  /**
   * Controla se o pagamento está sendo processado.
   */
  processando = false;

  /**
   * Opções de parcelamento calculadas pelo backend.
   *
   * O frontend NÃO calcula as taxas.
   * Ele apenas exibe o que o backend retornar.
   */
  opcoesParcelamento: OpcaoParcelamento[] = [];


  constructor(

    private checkoutService: CheckoutService,

    private router: Router,
    private cdr: ChangeDetectorRef

  ) {}


  ngOnInit(): void {

    this.carregarCheckout();

  }


  /**
   * Carrega os dados do checkout.
   */
  private carregarCheckout(): void {

    this.dados =
      this.checkoutService.obter();


    /*
     * Validação dos dados do checkout.
     */
    if (
      !this.dados ||
      !this.dados.quartoId
    ) {

      Swal.fire({

        icon: 'warning',

        title: 'Checkout não encontrado',

        text:
          'Os dados da reserva não foram encontrados.',

        confirmButtonText: 'OK',

        confirmButtonColor: '#596238'

      }).then(() => {

        this.router.navigate([
          '/cabana-ype'
        ]);

      });

      return;

    }


    /*
     * Validação dos hóspedes.
     */
    if (
      !this.dados.hospedes ||
      this.dados.hospedes.length === 0
    ) {

      Swal.fire({

        icon: 'warning',

        title: 'Hóspedes não encontrados',

        text:
          'Informe os dados dos hóspedes antes de continuar.',

        confirmButtonText: 'OK',

        confirmButtonColor: '#596238'

      }).then(() => {

        this.router.navigate([
          '/checkout/hospedes'
        ]);

      });

      return;

    }


    /*
     * A reserva precisa existir antes de
     * consultar as opções de parcelamento.
     */
    if (!this.dados.reservaId) {

      Swal.fire({

        icon: 'warning',

        title: 'Reserva não encontrada',

        text:
          'A reserva ainda não foi criada.',

        confirmButtonText: 'OK',

        confirmButtonColor: '#596238'

      }).then(() => {

        this.router.navigate([
          '/checkout/pagamento'
        ]);

      });

      return;

    }


    /*
     * Define a forma de pagamento.
     */
    this.checkoutService.atualizar({

      formaPagamento: 'CARTAO'

    });


    /*
     * Recarrega os dados atualizados.
     */
    this.dados =
      this.checkoutService.obter();


    /*
     * Recupera dados previamente preenchidos.
     */
    this.numeroCartao =
      this.dados.numeroCartao || '';

    this.nomeCartao =
      this.dados.nomeCartao || '';

    this.validadeCartao =
      this.dados.validadeCartao || '';

    this.cvv =
      this.dados.cvv || '';

    this.cpfCartao =
      this.dados.cpfCartao || '';


    /*
     * Recupera a parcela anteriormente selecionada.
     */
    this.parcelas =
      this.dados.parcelas || 1;


    /*
     * Busca no backend os valores das parcelas.
     */
    this.carregarOpcoesParcelamento();

  }


  /**
   * Busca no backend as opções de parcelamento.
   *
   * O backend é responsável por:
   *
   * - saber o valor real da reserva;
   * - aplicar a taxa de 1x;
   * - aplicar a taxa de 2x até 6x;
   * - limitar a quantidade de parcelas;
   * - calcular o valor final.
   */
  private carregarOpcoesParcelamento(): void {

    const reservaId =
      this.dados?.reservaId;


    if (!reservaId) {

      return;

    }


    this.checkoutService
      .obterOpcoesParcelamento(reservaId)
      .subscribe({

        next: (
          opcoes: OpcaoParcelamento[]
        ) => {

          this.opcoesParcelamento =
            opcoes;


          /*
           * Verifica se a parcela anteriormente
           * selecionada ainda existe.
           */
          const parcelaValida =
            this.opcoesParcelamento.some(
              opcao =>
                opcao.parcelas === this.parcelas
            );


          /*
           * Caso não exista, volta para 1x.
           */
          if (!parcelaValida) {

            this.parcelas = 1;

          }

          this.cdr.detectChanges();

        },


        error: () => {

          Swal.fire({

            icon: 'error',

            title: 'Erro',

            text:
              'Não foi possível carregar as opções de parcelamento.',

            confirmButtonText: 'OK',

            confirmButtonColor: '#596238'

          });

        }

      });

  }


  /**
   * Retorna a opção de parcelamento atualmente selecionada.
   */
  get opcaoParcelamentoSelecionada():
    OpcaoParcelamento | undefined {

    return this.opcoesParcelamento.find(
      opcao =>
        opcao.parcelas === this.parcelas
    );

  }


  /**
   * Valor total cobrado do cliente para a quantidade
   * de parcelas selecionada.
   *
   * Esse valor vem do backend.
   */
  get valorTotalComTaxa(): number {

    return (
      this.opcaoParcelamentoSelecionada
        ?.valorTotal || 0
    );

  }


  /**
   * Valor da parcela.
   *
   * Esse valor também vem do backend.
   */
  get valorParcelaSelecionada(): number {

    return (
      this.opcaoParcelamentoSelecionada
        ?.valorParcela || 0
    );

  }
  /**
   * Aguarda a confirmação do pagamento.
   *
   * Enquanto o pagamento estiver pendente,
   * o SweetAlert de carregamento permanece aberto.
   *
   * O usuário somente sai dessa tela quando:
   *
   * - PAGO
   * - CANCELADO
   * - EXPIRADO
   * - RECUSADO
   */
  private aguardarConfirmacaoPagamento(
    reservaId: number
  ): void {

    this.pararConsultaStatus();

    this.tentativasStatus = 0;

    this.consultarStatusPagamento(
      reservaId
    );

    this.intervaloStatus =
      setInterval(() => {

        this.consultarStatusPagamento(
          reservaId
        );

      }, 3000);

  }

  /**
   * Consulta o status do pagamento.
   */
  private consultarStatusPagamento(
    reservaId: number
  ): void {

    this.tentativasStatus++;

    console.log(
      `Consultando status do pagamento... tentativa ${this.tentativasStatus}`
    );

    this.checkoutService
      .consultarStatusPagamento(reservaId)
      .subscribe({

        next: (
          resposta: CheckoutReservaResponse
        ) => {

          const status =
            (
              resposta.status ||
              ''
            )
              .toString()
              .toUpperCase()
              .trim();

          console.log(
            'Status do pagamento:',
            status
          );


          /*
           * ========================================
           * PAGAMENTO CONFIRMADO
           * ========================================
           */
          if (
            status === 'PAGO'
          ) {

            this.pararConsultaStatus();

            this.processando = false;

            Swal.close();

            Swal.fire({

              icon: 'success',

              title:
                'Pagamento confirmado!',

              text:
                'Sua reserva foi confirmada com sucesso.',

              confirmButtonText:
                'Continuar',

              confirmButtonColor:
                '#596238',

              allowOutsideClick:
                false

            }).then(() => {

              this.router.navigate([
                '/checkout/sucesso'
              ]);

            });

            return;

          }


          /*
           * ========================================
           * PAGAMENTO AINDA EM PROCESSAMENTO
           * ========================================
           *
           * NÃO fazemos nada.
           *
           * O setInterval continuará consultando
           * a cada 3 segundos.
           *
           * O Swal de carregamento continuará aberto.
           */
          if (
            status === 'PENDENTE' ||
            status === 'PENDING' ||
            status === 'AWAITING_RISK_ANALYSIS' ||
            status === 'AWAITING_PAYMENT'
          ) {

            return;

          }


          /*
           * ========================================
           * PAGAMENTO NÃO REALIZADO
           * ========================================
           */
          if (
            status === 'CANCELADO' ||
            status === 'CANCELED' ||
            status === 'EXPIRADO' ||
            status === 'EXPIRED' ||
            status === 'RECUSADO' ||
            status === 'REFUSED' ||
            status === 'REFUNDED'
          ) {

            this.pararConsultaStatus();

            this.processando = false;

            Swal.close();

            Swal.fire({

              icon: 'error',

              title:
                'Pagamento não realizado',

              text:
                'O pagamento não foi confirmado pelo sistema de pagamento.',

              confirmButtonText:
                'Voltar',

              confirmButtonColor:
                '#596238'

            });

            return;

          }


          /*
           * ========================================
           * STATUS DESCONHECIDO
           * ========================================
           *
           * Não manda para sucesso.
           * Continua aguardando.
           */
          console.warn(
            'Status de pagamento não reconhecido:',
            status
          );

        },

        error: (
          erro: HttpErrorResponse
        ) => {

          /*
           * Não encerramos o loading por causa
           * de uma falha momentânea na consulta.
           *
           * A próxima consulta tentará novamente.
           */
          console.warn(
            'Erro ao consultar status do pagamento:',
            erro
          );

        }

      });

  }


  /**
   * Para a consulta de status.
   */
  private pararConsultaStatus(): void {

    if (
      this.intervaloStatus
    ) {

      clearInterval(
        this.intervaloStatus
      );

      this.intervaloStatus = null;

    }

  }


  /**
   * Formata número do cartão.
   */
  formatarCartao(): void {

    this.numeroCartao =

      this.numeroCartao

        .replace(/\D/g, '')

        .slice(0, 16)

        .replace(
          /(\d{4})(?=\d)/g,
          '$1 '
        );

  }


  /**
   * Formata validade MM/AA.
   */
  formatarValidade(): void {

    let valor =
      this.validadeCartao
        .replace(/\D/g, '')
        .slice(0, 4);


    if (valor.length > 2) {

      valor =
        valor.slice(0, 2) +
        '/' +
        valor.slice(2);

    }


    this.validadeCartao =
      valor;

  }


  /**
   * Formata CPF.
   */
  formatarCpf(): void {

    let valor =
      this.cpfCartao
        .replace(/\D/g, '')
        .slice(0, 11);


    if (valor.length > 9) {

      valor =
        valor.replace(
          /(\d{3})(\d{3})(\d{3})(\d{1,2})/,
          '$1.$2.$3-$4'
        );

    }

    else if (valor.length > 6) {

      valor =
        valor.replace(
          /(\d{3})(\d{3})(\d{1,3})/,
          '$1.$2.$3'
        );

    }

    else if (valor.length > 3) {

      valor =
        valor.replace(
          /(\d{3})(\d{1,3})/,
          '$1.$2'
        );

    }


    this.cpfCartao =
      valor;

  }


  /**
   * Valida CPF.
   */
  cpfValido(cpf: string): boolean {

    const valor =
      cpf.replace(/\D/g, '');


    if (valor.length !== 11) {

      return false;

    }


    if (/^(\d)\1{10}$/.test(valor)) {

      return false;

    }


    let soma = 0;


    for (
      let i = 0;
      i < 9;
      i++
    ) {

      soma +=
        Number(valor.charAt(i)) *
        (10 - i);

    }


    let resto =
      (soma * 10) % 11;


    if (resto === 10) {

      resto = 0;

    }


    if (
      resto !==
      Number(valor.charAt(9))
    ) {

      return false;

    }


    soma = 0;


    for (
      let i = 0;
      i < 10;
      i++
    ) {

      soma +=
        Number(valor.charAt(i)) *
        (11 - i);

    }


    resto =
      (soma * 10) % 11;


    if (resto === 10) {

      resto = 0;

    }


    return (
      resto ===
      Number(valor.charAt(10))
    );

  }


  /**
   * Valida validade do cartão.
   */
  validadeValida(): boolean {

    if (
      !this.validadeCartao ||
      this.validadeCartao.length !== 5
    ) {

      return false;

    }


    const partes =
      this.validadeCartao.split('/');


    if (partes.length !== 2) {

      return false;

    }


    const mes =
      Number(partes[0]);

    const ano =
      Number(partes[1]);


    if (
      !Number.isInteger(mes) ||
      !Number.isInteger(ano)
    ) {

      return false;

    }


    if (
      mes < 1 ||
      mes > 12
    ) {

      return false;

    }


    const anoCompleto =
      2000 + ano;


    const hoje =
      new Date();


    const anoAtual =
      hoje.getFullYear();

    const mesAtual =
      hoje.getMonth() + 1;


    if (
      anoCompleto < anoAtual
    ) {

      return false;

    }


    if (
      anoCompleto === anoAtual &&
      mes < mesAtual
    ) {

      return false;

    }


    return true;

  }


  /**
   * Descrição da acomodação.
   */
  get descricaoAcomodacao(): string {

    if (
      this.dados?.quartoId === 1
    ) {

      return 'Cabana confortável em meio à natureza';

    }


    if (
      this.dados?.quartoId === 2
    ) {

      return 'Um pedaço da Grécia em meio ao Cerrado de Goiás';

    }


    return 'Acomodação no Paraíso do Cerrado';

  }


  /**
   * Formata data para DD/MM/AAAA.
   */
  formatarData(
    data: string | undefined | null
  ): string {

    if (!data) {

      return '';

    }


    const partes =
      data.split('-');


    if (partes.length !== 3) {

      return data;

    }


    const [
      ano,
      mes,
      dia
    ] = partes;


    return `${dia}/${mes}/${ano}`;

  }


  /**
   * Processa o pagamento com cartão.
   */
  confirmarPagamento(): void {

    if (this.processando) {

      return;

    }


    const reservaId =
      this.dados?.reservaId;


    if (!reservaId) {

      this.alerta(
        'Os dados da reserva não foram encontrados.'
      );

      return;

    }


    /*
     * Garante que as opções de parcelamento
     * foram carregadas.
     */
    if (
      !this.opcoesParcelamento.length
    ) {

      this.alerta(
        'As opções de parcelamento ainda não foram carregadas.'
      );

      return;

    }


    /*
     * Verifica se a parcela selecionada
     * realmente existe nas opções retornadas
     * pelo backend.
     */
    const opcaoSelecionada =
      this.opcaoParcelamentoSelecionada;


    if (!opcaoSelecionada) {

      this.alerta(
        'Selecione uma opção de parcelamento válida.'
      );

      return;

    }


    /*
     * Regra adicional de segurança:
     * nunca permitir mais de 6 parcelas.
     */
    if (
      !this.parcelas ||
      this.parcelas < 1 ||
      this.parcelas > 6
    ) {

      this.alerta(
        'A quantidade de parcelas deve estar entre 1 e 6.'
      );

      return;

    }


    /*
     * Número do cartão.
     */
    const numeroLimpo =
      this.numeroCartao
        .replace(/\D/g, '');


    if (
      numeroLimpo.length !== 16
    ) {

      this.alerta(
        'Número do cartão inválido.'
      );

      return;

    }


    /*
     * Nome do titular.
     */
    if (
      !this.nomeCartao.trim()
    ) {

      this.alerta(
        'Informe o nome do titular do cartão.'
      );

      return;

    }


    /*
     * Validade.
     */
    if (
      !this.validadeValida()
    ) {

      this.alerta(
        'Informe uma validade válida.'
      );

      return;

    }


    /*
     * CVV.
     */
    const cvvLimpo =
      this.cvv.replace(/\D/g, '');


    if (
      cvvLimpo.length < 3 ||
      cvvLimpo.length > 4
    ) {

      this.alerta(
        'Informe um CVV válido.'
      );

      return;

    }


    /*
     * CPF.
     */
    const cpfLimpo =
      this.cpfCartao.replace(/\D/g, '');


    if (
      !this.cpfValido(cpfLimpo)
    ) {

      this.alerta(
        'Informe um CPF válido.'
      );

      return;

    }


    /*
     * Salva os dados no checkout local.
     */
    this.checkoutService.atualizar({

      numeroCartao:
      numeroLimpo,

      nomeCartao:
        this.nomeCartao.trim(),

      validadeCartao:
      this.validadeCartao,

      cvv:
      cvvLimpo,

      cpfCartao:
      cpfLimpo,

      parcelas:
      this.parcelas,

      formaPagamento:
        'CARTAO'

    });


    /*
     * IMPORTANTE:
     *
     * Não enviamos valorTotal para o backend.
     *
     * O backend recebe somente a quantidade de parcelas
     * e calcula novamente o valor com a taxa.
     */
    const pagamento:
      PagamentoCartaoRequest = {

      numeroCartao:
      numeroLimpo,

      nomeCartao:
        this.nomeCartao.trim(),

      validadeCartao:
      this.validadeCartao,

      cvv:
      cvvLimpo,

      cpfCartao:
      cpfLimpo,

      parcelas:
      this.parcelas

    };


    this.processando = true;


    Swal.fire({

      title:
        'Aguarde um momento...',

      text:
        'Estamos processando seu pagamento. Não feche esta página.',

      allowOutsideClick:
        false,

      allowEscapeKey:
        false,

      showConfirmButton:
        false,

      didOpen: () => {

        Swal.showLoading();

      }

    });


    this.checkoutService
      .criarPagamentoCartao(
        reservaId,
        pagamento
      )
      .subscribe({

        next: (
          resposta: CheckoutReservaResponse
        ) => {

          this.checkoutService.salvarPagamento(
            resposta
          );


          this.dados =
            this.checkoutService.obter();


          this.aguardarConfirmacaoPagamento(
            reservaId
          );

        },


        error: (
          erro: HttpErrorResponse
        ) => {

          this.processando = false;

          this.pararConsultaStatus();

          Swal.close();


          let mensagem =
            'Não foi possível iniciar o pagamento.';


          if (
            erro.error &&
            typeof erro.error === 'object' &&
            erro.error.message
          ) {

            mensagem =
              erro.error.message;

          }

          else if (
            typeof erro.error === 'string' &&
            erro.error.trim()
          ) {

            mensagem =
              erro.error;

          }


          Swal.fire({

            icon: 'error',

            title:
              'Não foi possível processar',

            text:
            mensagem,

            confirmButtonText:
              'Corrigir dados',

            confirmButtonColor:
              '#596238',

            customClass: {

              popup:
                'swal-cabana'

            }

          });

        }

      });

  }


  /**
   * Volta para a tela anterior.
   */
  voltar(): void {

    this.router.navigate([
      '/checkout/pagamento'
    ]);

  }


  /**
   * Exibe alerta.
   */
  private alerta(
    texto: string
  ): void {

    Swal.fire({

      icon: 'warning',

      title:
        'Verifique os dados',

      text:
      texto,

      confirmButtonText:
        'OK',

      confirmButtonColor:
        '#596238',

      customClass: {

        popup:
          'swal-cabana'

      }

    });

  }


  /**
   * Valor original da reserva.
   *
   * IMPORTANTE:
   * esse é o valor líquido que o estabelecimento
   * deve receber.
   */
  get valorTotal(): number {

    return (
      this.dados?.valorTotal ||
      0
    );

  }


  get quantidadeNoites(): number {

    return (
      this.dados?.quantidadeNoites ||
      0
    );

  }


  get checkIn(): string {

    return (
      this.dados?.checkIn ||
      ''
    );

  }


  get checkOut(): string {

    return (
      this.dados?.checkOut ||
      ''
    );

  }


  get quartoNome(): string {

    return this.dados?.quartoNome ?? '';

  }


  get quartoImagem(): string {

    return this.dados?.quartoImagem ?? '';

  }

}
